<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">千橙连锁解决方案</div>
        <div class="line" />
        <div class="desc">
          满足直营、加盟、联营不同业态经营需求，为连锁零售企业提供多门店管理能力，实现集中化管理、统一运营
        </div>
        <div class="btn-wrap">
          <div class="btn1" @click="openLoginModal">免费试用</div>
          <div class="btn" @click="openModal">立即咨询</div>
        </div>
      </div>
    </div>
    <div class="tradition">
      <div class="sk-block-title" style="padding-top: 48px">
        <div class="title">传统连锁经营面临的烦恼</div>
      </div>
      <div class="content">
        <div class="content_box">
            <div class="box_left">
                <img src="~@/assets/images/QcChain/tradition1.png" />
            </div>
            <div class="box_right">
                <div class="content_title">多门店管理成本高</div>
                <ul>
                    <li><div>多门店管理困难，运营成本加大</div></li>
                    <li><div>员工管理混乱，店铺数据不安全</div></li>
                    <li><div>收付款不规范，账目不清晰</div></li>
                    <li><div>商品来源繁杂，无法清晰管理</div></li>
                </ul>
            </div>
        </div>
        <div class="content_box">
            <div class="box_left">
                <img src="~@/assets/images/QcChain/tradition2.png" />
            </div>
            <div class="box_right">
                <div class="content_title">单门店经营效率低</div>
                <ul>
                    <li><div>线上/线下会员单门店经营，无法统一管理</div></li>
                    <li><div>各店铺营销活动割裂，无法区域联动</div></li>
                    <li><div>门店单店采购结算，不利统谈统采</div></li>
                    <li><div>经营数据隔离，不便于汇总查看</div></li>
                </ul>
            </div>
        </div>
      </div>
    </div>
    <div class="chain_box">
        <div class="sk-block-title" style="padding-top: 48px">
            <div class="title">
                全链路系统集成，数字化连锁解决方案
            </div>
        </div>
        <div class="content"></div>
    </div>
    <div class="chain_mode">
        <div class="sk-block-title" style="padding-top: 48px">
            <div class="title">
                多种经营模式，供商家灵活选择
            </div>
        </div>
        <div class="content">
            <div class="content_box content_box1">
                <div class="chain_mode_title">直营模式</div>
                <ul>
                    <li><div>统一商品管控，实现更高效的供应链管理</div></li>
                    <li><div>统一粉丝经营，提高粉丝忠诚度和参与度</div></li>
                    <li><div>统一营销活动，实现更好的营销效果</div></li>
                    <li><div>统一报表管理，便于总部进行决策和分析</div></li>
                </ul>
            </div>
            <div class="content_box content_box2">
                <div class="chain_mode_title">加盟模式</div>
                <ul>
                    <li><div>商品采购多样化，支持“总部同步+加盟自建”商品池</div></li>
                    <li><div>粉丝运营多元化，支持不同粉丝经营方式</div></li>
                    <li><div>营销活动灵活化，支持总分联动不同营销活动</div></li>
                    <li><div>财务管理独立化，支持加盟店自主收款</div></li>
                </ul>
            </div>
            <div class="content_box content_box3">
                <div class="chain_mode_title">联营模式</div>
                <ul>
                    <li><div>独立商品池，更多的自主权和灵活性</div></li>
                    <li><div>独立经营粉丝群体，更大的自主性和个性化</div></li>
                    <li><div>独立策划营销活动，更具有针对性和个性化的营销方案</div></li>
                    <li><div>独立财务管理，总部利润分成，更好的财务收益</div></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="marketing">
        <div class="content">
            <p class="marketing_title">多渠道会员统一，全域营销活动，让会员活起来</p>
        </div>
    </div>
    <div class="control">
        <div class="sk-block-title" style="padding-top: 48px">
            <div class="title">
                多维度、全方位的经营数据分析，便于经营决策高效管控
            </div>
        </div>
        <div class="content"></div>
    </div>
    <div class="service">
      <div class="sk-block-title1">
        <div class="title1" style="color:#ffffff">行业解决方案</div>
      </div>
      <div class="content">
        <div class="service_box">
          <img src="@/assets/images/QcChain/box1.png" alt="" />
          <div class="box_title">家用电器</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcChain/box2.png" alt="" />
          <div class="box_title">生鲜水果</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcChain/box3.png" alt="" />
          <div class="box_title">酒水饮料</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcChain/box4.png" alt="" />
          <div class="box_title">数码3C</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcChain/box5.png" alt="" />
          <div class="box_title">商场超市</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcChain/box6.png" alt="" />
          <div class="box_title">轻餐茶饮</div>
        </div>
      </div>
    </div>
    <Contact :infoSources="'千橙连锁'" />
    <TryModal
      v-if="visible"
      :visible="visible"
      info-sources="社群分销"
      @cancel="modalClose"
    />
    <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'3'"
        />
  </div>
</template>

<script>
import metaInfo from "@/common/util/metaInfo";
import TryModal from "@/components/TryModal";
import Contact from "@/components/Contact";
import LoginModal from '@/components/LoginModal'

export default {
  metaInfo: metaInfo.QcChain,
  components: {
    TryModal,
    Contact,
    LoginModal
  },
  data() {
    return {
      visible: false,
      toolBg: require("@/assets/images/QcCashier/tool1.png"),
      tooItem: "1",
      showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
    };
  },
  mounted() {},
  methods: {
    // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
    checkBg(item) {
      this.tooItem = item;
      this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
    },
    openModal: function () {
      this.visible = true;
    },
    modalClose: function (data) {
      this.visible = data;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ i.el-icon-arrow-left {
  font-size: 35px;
  font-weight: 600;
}
/deep/ i.el-icon-arrow-right {
  font-size: 35px;
  font-weight: 600;
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--left,
button.el-carousel__arrow.el-carousel__arrow--right {
  width: 50px;
  height: 86px;
  border-radius: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--right {
  width: 50px;
  height: 86px;
  border-radius: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}
.service {
  height: 510px;
  background: url("~@/assets/images/QcChain/carousel_bg.png") no-repeat
    center;
  background-size: 100% 510px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    display: flex;
    flex-direction: row;
    height: 255px;
    justify-content: space-between;
    .service_box {
      width: 110px;
      display: flex;
      flex-direction: column;
      height: 168px;
      justify-content: space-between;
      align-items: center;
      img {
        width: 110px;
        height: 110px;
      }
      .box_title {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 28px;
      }
      .box_text {
        // width: 192px;
        height: 72px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
    }
  }
}
.custom {
  height: 662px;
  background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat
    center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    background: rgba(255, 255, 255, 0.5);
    // background: #FFFFFF;
    // opacity: 0.55;
    // border-radius: 8px;
    margin-top: 42px;
    height: 439px;
    .custom_item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 150px;
      .cutom_box {
        width: 260px;
        height: 89px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 140px;
        .box_item {
          display: flex;
          flex-direction: column;
          .box_title {
            width: 71px;
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 45px;
          }
          .box_line {
            width: 43px;
            height: 5px;
            background: #3986ff;
          }
          .box_span {
            width: 96px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #595961;
            line-height: 22px;
          }
        }
      }
      .custom_item_text {
        margin-left: 50px;
        .title {
          height: 40px;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
        }
        .text {
          height: 20px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          margin-top: 30px;
        }
      }
      img {
        width: 438px;
        height: 302px;
      }
    }
  }
}
.case {
  background: #f8fbff;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 1171px;
      height: 397px;
    }
  }
}
.content_title {
  height: 30px;
  font-size: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}
.content-center {
  ul,
  li {
    list-style: disc;
  }
  // .banner {
  //   background: url("~@/assets/images/community/community_banner.png") no-repeat center;
  //   min-width: 1200px;
  //   .btn-wrap {
  //     width: 1200px;
  //     margin: 0 auto;
  //     padding: 309px 0 53px;
  //     .btn {
  //       width: 200px;
  //       height: 58px;
  //       line-height: 58px;
  //       border-radius: 6px;
  //       border: 1px solid #FFFFFF;
  //       font-size: 22px;
  //       color: #FFFFFF;
  //       cursor: pointer;
  //     }
  //   }
  // }
  .banner {
    background: url("~@/assets/images/QcChain/QcChain_banner.png") no-repeat
      center;
    background-size: 100% 100%;
    height: 421px;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #ffffff;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28dafb;
        margin: 16px 0 31px;
      }
      .desc {
        width: 522px;
        height: 101px;
        font-size: 20px;
        color: #ffffff;
        font-weight: normal;
        line-height: 28px;
        .desc-content {
          width: 618px;
          height: 96px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }
      }
      .btn-wrap {
        display: flex;
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #ffffff;
          font-size: 22px;
          color: #ffffff;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
          margin-left: 20px;
        }
        .btn1 {
          width: 200px;
          height: 58px;
          line-height: 58px;
          background: #3986ff;
          border-radius: 6px;
          font-size: 22px;
          color: #ffffff;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
          //   margin-left:20px;
        }
      }
    }
  }
  .distribution {
    background: #ffffff;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0 124px 0;
      .item {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        width: 238px;
        height: 340px;
        // background: #FFFFFF;
        // box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        // border-radius: 6px;
        justify-content: center;
        align-items: center;
        padding: 28px 28px;
        // background: fixed url("~@/assets/images/qcerpsystem/content_bg.png") no-repeat center;
        // background-size: 100% 100%;
        img {
          width: 144px;
          height: 144px;
        }
        span {
          margin-top: 12px;
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        div {
          margin-top: 12px;
          width: 40px;
          height: 6px;
          background: #2f81e8;
        }
        p {
          margin-top: 6px;
          width: 219px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }
  }
  .shop {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content {
      width: 1200px;
      height: 503px;
      text-align: center;
      margin: 17px 0 51px 0;
      background: url("~@/assets/images/qcerpsystem/shop_bg.png") no-repeat
        center;
      background-size: 1200px 503px;
      .content_left {
        width: 300px;
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        float: right;
        .content_box {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: 40px;
          .content_box_left {
            width: 24px;
            img {
              width: 24px;
              height: 24px;
            }
          }
          .content_box_right {
            width: 200px;
            text-align: left;
            // height: 33px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
          }
        }
      }
    }
  }
  .sub-title {
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
    margin-bottom: 20px;
  }
  .sub-content {
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
  }
  .sharp {
    background: #f8fbff;
    .content {
      width: 1159px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 57px 0 60px 0;
      .right {
        width: 578px;
        text-align: left;
      }
      img {
        width: 612px;
        height: 368px;
      }
    }
  }
  .content-box {
    display: flex;
    flex-direction: row;
    margin-top: 52px;
    .content-box-left {
      width: 24px;
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .content-box-right {
      //   width: 383px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      margin-left: 15px;
    }
  }
  .coreFun {
    padding-bottom: 73px;
    // background: #FAFAFA;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1179px;
      margin: 60px auto 0;
      .left {
        width: 600px;
        text-align: left;
      }
      .content_bg {
        width: 612px;
        height: 368px;
      }
    }
  }
  .tradition {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 458px;
    background: #ffffff;
    .content {
      width: 1200px;
      height: 248px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      .content_box{
        width: 580px;
        height: 248px;
        background: url("~@/assets/images/QcChain/tradition_bg.png") no-repeat center;
        background-size: 580px 248px;
        display: flex;
        flex-direction: row;
        .box_left{
            width: 107px;
            height:121px;
            margin-left: 34px;
            margin-top:60px;
            img{
                width: 107px;
                height:121px;
            }
        }
        .box_right{
            width: 400px;
            margin-left:39px;
            .content_title{
                margin-top:40px;
                height: 30px;
                font-size: 22px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 30px;
                text-align: left;
            }
            ul{
                margin-top:20px;
            }
            li{
                list-style: disc;
                text-align: left;
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 22px;
                margin-bottom:10px;
            }
        }
      }
    }
  }
  .chain_mode{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #FAFAFA;
    height: 532px;
    .content{
        width: 1200px;
        height:332px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 38px;
        .content_box1{
            background: url("~@/assets/images/QcChain/chain_mode1.png") no-repeat center;
            background-size: 384px 332px;
        }
        .content_box2{
            background: url("~@/assets/images/QcChain/chain_mode2.png") no-repeat center;
            background-size: 384px 332px;
        }
        .content_box3{
            background: url("~@/assets/images/QcChain/chain_mode3.png") no-repeat center;
            background-size: 384px 332px;
        }
        .content_box{
            width: 384px;
            height: 332px;
            text-align: left;
            position:relative;
            img{
                position: absolute;
                top: 0;
                left: 0;
                width: 384px;
                height: 332px;
            }
            .chain_mode_title{
                height: 37px;
                font-size: 26px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #040A24;
                line-height: 37px;
                margin-left: 27px;
                margin-top:32px;
            }
            ul{
                margin-left:39px;
                margin-top: 52px;
            }
            li{
                color:#114BFB;
                div{
                    width: 326px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 21px;
                    margin-bottom:25px;
                }
            }
        }
    }
  }
  .control{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 898px;
    background: #FFFFFF;
    .content{
        width: 1200px;
        height:688px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;
        background: url("~@/assets/images/QcChain/control_bg.png") no-repeat center;
        background-size: 1200px 688px;
    }
  }
  .marketing{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #FAFAFA;
    height: 712px;
    .marketing_title{
        height: 50px;
        font-size: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 50px;
    }
    .content{
        width: 1200px;
        height:582px;
        display: flex;
        // flex-direction: row;
        // align-items: center;
        justify-content: center;
        background: url("~@/assets/images/QcChain/marketing_bg.png") no-repeat center;
        background-size: 1200px 582px;
    }
  }
  .chain_box{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #FAFAFA;
    height: 791px;
    .content{
        width: 1200px;
        height:561px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 60px;
        background: url("~@/assets/images/QcChain/chain_box1.png") no-repeat center;
        background-size: 1200px 561px;
    }
  }
  .programme {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fb;
    height: 667px;
    .content {
      width: 1200px;
      height: 458px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 60px;
      .programme_box {
        width: 321px;
        height: 458px;
        background: #ffffff;
        border-radius: 8px;
        padding-left: 20px;
        position: relative;
        .box_bg {
          width: 276px;
          height: 222px;
          position: absolute;
          bottom: 0;
          left: 2px;
        }
        .programme_ul {
          width: 301px;
          display: flex;
          flex-direction: column;
          margin-top: 32px;
          .programme_li {
            width: 100%;
            display: flex;
            flex-direction: row;
            margin-bottom: 15px;
            img {
              width: 14px;
              height: 14px;
              margin-right: 8px;
              margin-top: 3px;
            }
            span {
              width: 226px;
              // height: 40px;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #595961;
              line-height: 20px;
              text-align: left;
            }
          }
        }
        .programme_box_item_title {
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #595961;
          line-height: 28px;
          text-align: left;
          margin-top: 30px;
        }
        .programme_box_item_text {
          width: 301px;
          height: 44px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #595961;
          line-height: 22px;
          text-align: left;
          margin-top: 16px;
        }
      }
    }
  }
  .scene1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fb;
    .content2 {
      width: 1920px;
      height: 685px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg2.png") no-repeat
        center;
      background-size: 1920px 685px;
    }
    .content4 {
      width: 1920px;
      height: 649px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg4.png") no-repeat
        center;
      background-size: 1920px 649px;
    }
  }
  .scene {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    .content1 {
      width: 1920px;
      height: 836px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg1.png") no-repeat
        center;
      background-size: 1920px 836px;
    }
    .content3 {
      width: 1920px;
      height: 685px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg3.png") no-repeat
        center;
      background-size: 1920px 685px;
    }
    .content5 {
      width: 1920px;
      height: 674px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg5.png") no-repeat
        center;
      background-size: 1920px 674px;
    }
  }
}
</style>
